export default function ({ children, isLoading }) {
    return (
        <div className={"section " + (isLoading ? 'loading' : '')}>
            {children}
            <span className="loader"></span>
        </div>
    )
}